module.exports = __webpack_public_path__ + "img/DE00238.922047f4.png";